import { render, staticRenderFns } from "./MyTemplate.vue?vue&type=template&id=6a1a0526&"
import script from "./MyTemplate.vue?vue&type=script&lang=js&"
export * from "./MyTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports